import footerLogo from "./assets/robogebra-footer-logo.svg"
import scrollIcon from "./assets/scroll-to-top.svg"
import sampleSolution1 from "./assets/sample-solutions/box-sum.png"
import sampleSolution2 from "./assets/sample-solutions/solutionimage11.png"
import sampleSolution3 from "./assets/sample-solutions/solutionimage12.png"
import sampleSolution4 from "./assets/sample-solutions/solutionimage5.png"
import robogebraOGBanner from "./assets/sample-solutions/robogebra-og.png"



//navbar-overlay-menu
document.addEventListener("DOMContentLoaded", function () {
    const robogebraOGBanner1 = robogebraOGBanner; // TODO... Don't Remove
    const menuIcon = document.getElementById('menuIcon');
    if (menuIcon) {
        menuIcon.addEventListener('click', toggleMenu);
    }

    const overlayMenuIcon = document.getElementById('overlayMenu');
    if (overlayMenuIcon) {
        overlayMenuIcon.addEventListener('click', onOverlayMenuClick);
    }

    function toggleMenu() {
        overlayMenuIcon.classList.toggle('open');
        if (overlayMenuIcon.classList.contains('open')) {
            menuIcon.classList.remove('fa-bars');
            menuIcon.classList.add('fa-times');
        } else {
            menuIcon.classList.remove('fa-times');
            menuIcon.classList.add('fa-bars');
        }
    }

    function onOverlayMenuClick() {
        overlayMenuIcon.classList.toggle('open');
        menuIcon.classList.remove('fa-times');
        menuIcon.classList.add('fa-bars');
    }
});

//scroll-top-fuctionality
document.addEventListener("DOMContentLoaded", function () {
    const backToTopButton = document.getElementById("scrollTopBtn");

    if (backToTopButton) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > window.innerHeight) {
                backToTopButton.style.display = "block";
            } else {
                backToTopButton.style.display = "none";
            }
        });

        backToTopButton.addEventListener("click", () => {
            window.scrollTo({top: 0, behavior: "smooth"});
        });
    }
});

// --- Referral Source → Signup Redirect ---
document.addEventListener('DOMContentLoaded', function () {
    const googleSignupBtn = document.getElementById('googleSignupBtn');

    if (googleSignupBtn) {
        googleSignupBtn.addEventListener('click', function () {
            window.open('https://app.robogebra.ai/signup', '_blank', 'noopener,noreferrer');
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.abt-see-more-btn');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const container = this.closest('.team-container');

            // Toggle expansion
            container.classList.toggle('expanded');

            // Optional: Toggle button text
            if (container.classList.contains('expanded')) {
                this.textContent = 'See less...';
            } else {
                this.textContent = 'See more...';
            }
        });
    });

    // Collapse when clicking outside
    document.addEventListener('click', function (event) {
        const expandedContainers = document.querySelectorAll('.team-container.expanded');

        expandedContainers.forEach(container => {
            if (!container.contains(event.target)) {
                container.classList.remove('expanded');

                // Reset the button text to "See more"
                const btn = container.querySelector('.abt-see-more-btn');
                if (btn) btn.textContent = 'See more...';
            }
        });
    });
});

// About-us section logic
document.addEventListener("DOMContentLoaded", () => {
    const topBio = document.getElementById("top-bio");
    const cards = document.querySelectorAll(".team-card");

    if (!topBio || cards.length === 0) return;

    // Attach click listeners to all cards
    cards.forEach(card => {
        card.addEventListener("click", () => {
            // Remove 'active' class from all cards
            cards.forEach(c => c.classList.remove("active"));
            // Add 'active' class to clicked card
            card.classList.add("active");

            // Show the bio
            const bio = card.getAttribute("data-bio");
            topBio.innerText = bio;
            topBio.classList.add("visible");
        });
    });
    // Select the first card by default
    cards[0].click();
});

// Audio Player Functionality
document.addEventListener('DOMContentLoaded', function() {
    const audioPlayer = document.getElementById('audioPlayer');
    const playPauseBtn = document.getElementById('playPauseBtn');

    if (!audioPlayer || !playPauseBtn) return;

    const playIcon = playPauseBtn.querySelector('.play-icon');
    const pauseIcon = playPauseBtn.querySelector('.pause-icon');
    const progressFill = document.getElementById('progressFill');
    const progressThumb = document.getElementById('progressThumb');
    const progressBar = document.querySelector('.progress-bar');
    const currentTimeDisplay = document.getElementById('currentTime');

    let isDragging = false;

    // Format time helper function
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    // Update progress bar
    function updateProgress() {
        if (isDragging) return;

        const duration = audioPlayer.duration || 0;
        const currentTime = audioPlayer.currentTime || 0;
        const progressPercent = duration ? (currentTime / duration) * 100 : 0;

        progressFill.style.width = progressPercent + '%';
        progressThumb.style.left = progressPercent + '%';
        currentTimeDisplay.textContent = formatTime(currentTime);
    }

    // Play/Pause functionality
    playPauseBtn.addEventListener('click', function() {
        if (audioPlayer.paused) {
            audioPlayer.play().then(() => {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            }).catch(error => {
                console.error('Error playing audio:', error);
            });
        } else {
            audioPlayer.pause();
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        }
    });

    // Progress bar click/drag functionality
    function updateAudioTime(event) {
        const progressBarRect = progressBar.getBoundingClientRect();
        const clickX = event.clientX - progressBarRect.left;
        const progressBarWidth = progressBarRect.width;
        const clickPercent = (clickX / progressBarWidth) * 100;
        const newTime = (clickPercent / 100) * audioPlayer.duration;

        if (isFinite(newTime)) {
            audioPlayer.currentTime = newTime;
            updateProgress();
        }
    }

    progressBar.addEventListener('click', updateAudioTime);

    // Drag functionality for progress thumb
    progressThumb.addEventListener('mousedown', function(e) {
        isDragging = true;
        e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
        if (isDragging) {
            updateAudioTime(e);
        }
    });

    document.addEventListener('mouseup', function() {
        isDragging = false;
    });

    // Audio event listeners
    audioPlayer.addEventListener('timeupdate', updateProgress);

    audioPlayer.addEventListener('loadedmetadata', function() {
        currentTimeDisplay.textContent = formatTime(0);
        updateProgress();
    });

    audioPlayer.addEventListener('ended', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        progressFill.style.width = '0%';
        progressThumb.style.left = '0%';
        currentTimeDisplay.textContent = formatTime(0);
    });

    // Initialize display
    currentTimeDisplay.textContent = '03:00'; // Default duration as shown in image
});

// Coming Soon Modal Functions - Global scope
window.showComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }
}

window.hideComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

// Close modal when clicking outside of it
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                hideComingSoonModal();
            }
        });
    }

    // Load shared footer
    loadSharedFooter();
});

// Shared Footer Component
function loadSharedFooter() {
    const footerHTML = `
        <footer class="footer-container">
            <div class="container-xl">
                <div class="row py-md-5 justify-content-center">
                    <!-- Logo Section -->
                    <div class="col-md-4 col-sm-12 d-flex flex-column align-items-center justify-content-center footer-logo-section">
                        <img src="${footerLogo}" alt="Robogebra Logo" class="footer-logo-img">
                    </div>

                    <!-- Company Section -->
                    <div class="col-md-4 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #6b6b6b; font-weight: 400; text-transform: uppercase; font-size: 14px;" class="mb-0">Company</h5>
                        <ul class="list-unstyled mt-3 mb-0 ms-3">
                            <li class="mb-2"><a href="./index.html#pricing" style="color: #8B4B99; text-decoration: none;">Pricing</a></li>
                            <li class="mb-2"><a href="./about-us.html" style="color: #8B4B99; text-decoration: none;">About Us</a></li>
                            <li class="mb-2"><a href="./team.html" style="color: #8B4B99; text-decoration: none;">Team</a></li>
                            <li class="mb-2"><a href="./contact-us.html" style="color: #8B4B99; text-decoration: none;">Contact Us</a></li>
                            <li class="mb-2"><a href="https://app.robogebra.ai/login" target="_blank" style="color: #8B4B99; text-decoration: none;">Sign in</a></li>
                        </ul>
                    </div>

                    <!-- Connect with Us Section -->
                    <div class="col-md-4 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #6b6b6b; font-weight: 400; text-transform: uppercase; font-size: 14px; margin-left: 24px;" class="mb-0">Connect with Us</h5>
                        <ul class="list-unstyled mt-3  mb-0">
                            <li class="mb-2">
                                <a href="https://www.linkedin.com/company/robogebra-ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-linkedin" style="color: #8B4B99; margin-right: 8px;"></i>LinkedIn
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.youtube.com/@robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-youtube" style="color: #8B4B99; margin-right: 8px;"></i>YouTube
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.instagram.com/robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-instagram" style="color: #8B4B99; margin-right: 8px;"></i>Instagram
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://x.com/robogebra_ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-x-twitter" style="color: #8B4B99; margin-right: 8px;"></i>X
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://robogebra.discourse.group/" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-discourse" style="color: #8B4B99; margin-right: 8px;"></i>Community
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Bottom Footer Bar -->
        <div class="bottom-footer-bar">
            <div class="container-xl">
                <div class="row py-3 align-items-center justify-content-center">
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Contact Us</strong>
                            <a href="mailto:support@robogebra.ai" style="color: #9ca3af; text-decoration: none;">support@robogebra.ai</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Legal</strong>
                            <a href="./terms.html" style="color: #9ca3af; text-decoration: none;">Terms of Service</a>
                            <span class="mx-2" style="color: #9ca3af;">|</span>
                            <a href="./policy.html" style="color: #9ca3af; text-decoration: none;">Privacy Policy</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;"><strong style="color: #fff;">Copyright</strong> © 2025 Robogebra LLP</p>
                    </div>
                </div>
            </div>
        </div>
        
        
        <button id="scrollTopBtn" class="scroll-top-btn" style="cursor: pointer!important;">
            <img src="${scrollIcon}" alt="scroll-icon" class="scroll-icon me-1">
            Go to Top
        </button>
    `;

    // Find existing footer and replace it, or add to end of body if no footer exists
    const existingFooter = document.querySelector('footer.footer-container');
    const existingScrollBtn = document.querySelector('#scrollTopBtn');
    const existingBottomFooter = document.querySelector('.bottom-footer-bar');

    if (existingFooter) {
        // Remove existing components
        existingFooter.remove();
        if (existingScrollBtn) existingScrollBtn.remove();
        if (existingBottomFooter) existingBottomFooter.remove();
    }

    // Add the new footer before the last script tag
    const scripts = document.querySelectorAll('script');
    const lastScript = scripts[scripts.length - 1];
    lastScript.insertAdjacentHTML('beforebegin', footerHTML);

    // Initialize scroll to top functionality
    initializeScrollToTop();
}

// Initialize scroll to top functionality
function initializeScrollToTop() {
    const scrollTopBtn = document.getElementById('scrollTopBtn');
    if (scrollTopBtn) {
        // Show/hide scroll button based on scroll position
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 300) {
                scrollTopBtn.style.display = 'flex';
            } else {
                scrollTopBtn.style.display = 'none';
            }
        });

        // Scroll to top when button is clicked
        scrollTopBtn.addEventListener('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}
const solutionData = [
    {
        id: 1,
        image: sampleSolution1,
        url:"https://app.robogebra.ai/exercise/6745963c7ce9d810b13f1828/exercise-item/17/solution"
    },
    {
        id: 2,
        image: sampleSolution3,
        url:"https://app.robogebra.ai/exercise/687b3c32cca0583e95ec69ca/exercise-item/1/solution"
    },
    {
        id: 3,
        image: sampleSolution2,
        url:"https://app.robogebra.ai/exercise/673601373f90cacab21ea985/exercise-item/6/solution"
    },
    {
        id: 4,
        image: sampleSolution4,
        url:"https://app.robogebra.ai/exercise/673601393f90cacab21ea9c1/exercise-item/4/solution"
    }
];
const solutionsGrid = document.getElementById('solutionsGrid');
const modalOverlay = document.getElementById('modalOverlay');
const modalImage = document.getElementById('modalImage');
const modalClose = document.getElementById('modalClose');
function createGridItems() {
    solutionsGrid.innerHTML = '';

    solutionData.forEach(solution => {
        const gridItem = document.createElement('div');
        gridItem.className = 'solution-item';
        gridItem.innerHTML = `
            <img class="solution-image" src="${solution.image}" loading="lazy">
            <div class="solution-overlay">
                <div class="zoom-icon">🔍</div>
            </div>`;

        gridItem.addEventListener('click', () => {
            if (solution.url) {
                window.open(solution.url, '_blank', 'noopener,noreferrer');
            }
        });

        const img = gridItem.querySelector('.solution-image');
        img.addEventListener('error', () => {
            img.style.color = 'white';
            img.style.display = 'flex';
            img.style.alignItems = 'center';
            img.style.justifyContent = 'center';
            img.style.fontSize = '1.2rem';
            img.style.fontWeight = '600';
            img.alt = 'Sample Solution';
        });

        solutionsGrid.appendChild(gridItem);
    });
}

function openModal(solution) {
    modalImage.src = solution.image;
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}


function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}


modalClose.addEventListener('click', closeModal);

modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) {
        closeModal();
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
        closeModal();
    }
});
document.addEventListener('DOMContentLoaded', () => {
    createGridItems();
});

// Download Section Video Player
document.addEventListener('DOMContentLoaded', function() {
    const downloadImageContainer = document.getElementById('downloadImageContainer');
    const downloadVideoWrapper = document.getElementById('downloadVideoWrapper');
    const downloadVideoIframe = document.getElementById('downloadVideoIframe');

    if (downloadImageContainer && downloadVideoWrapper && downloadVideoIframe) {
        downloadImageContainer.addEventListener('click', function() {
            // Hide the image container
            downloadImageContainer.style.display = 'none';

            // Show the video wrapper with purple frame
            downloadVideoWrapper.style.display = 'block';

            // Set the video URL with autoplay
            downloadVideoIframe.src = 'https://www.youtube.com/embed/NFuTAZ46bSE?autoplay=1';
        });
    }

    // Testimonials Carousel
    const track = document.querySelector('.testimonials-track');
    const prevBtn = document.querySelector('.testimonial-prev');
    const nextBtn = document.querySelector('.testimonial-next');

    if (track && prevBtn && nextBtn) {
        // Align to real card positions instead of a fixed step, so the gap
        // difference across breakpoints can never make cards drift off-edge.
        const getCards = () => Array.from(track.querySelectorAll('.testimonial-card'));

        const getCurrentIndex = () => {
            const cards = getCards();
            const trackLeft = track.getBoundingClientRect().left;
            let index = 0;
            let closest = Infinity;
            cards.forEach((card, i) => {
                const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
                if (distance < closest - 1) {
                    closest = distance;
                    index = i;
                }
            });
            return index;
        };

        const scrollToIndex = (index) => {
            const cards = getCards();
            if (!cards.length) return;
            const target = cards[Math.max(0, Math.min(index, cards.length - 1))];
            const delta = target.getBoundingClientRect().left - track.getBoundingClientRect().left;
            track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
        };

        const isAtEnd = () => track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;

        prevBtn.addEventListener('click', () => scrollToIndex(getCurrentIndex() - 1));
        nextBtn.addEventListener('click', () => scrollToIndex(getCurrentIndex() + 1));

        const advance = () => {
            if (isAtEnd()) {
                scrollToIndex(0);
            } else {
                scrollToIndex(getCurrentIndex() + 1);
            }
        };

        // Auto-scroll every 4 seconds
        let autoScroll = setInterval(advance, 4000);

        const pause = () => clearInterval(autoScroll);
        const resume = () => {
            clearInterval(autoScroll);
            autoScroll = setInterval(advance, 4000);
        };

        // Pause auto-scroll while the user is interacting
        track.addEventListener('mouseenter', pause);
        track.addEventListener('mouseleave', resume);
        track.addEventListener('touchstart', pause, { passive: true });
        track.addEventListener('touchend', resume, { passive: true });

        // Re-align after a resize / orientation change
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            const index = getCurrentIndex();
            resizeTimer = setTimeout(() => scrollToIndex(index), 150);
        });
    }
});
